import script from "./AudioRecorder.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioRecorder.vue?vue&type=script&setup=true&lang=ts"

import "./AudioRecorder.vue?vue&type=style&index=0&id=06dd3206&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06dd3206"]])

export default __exports__